export const CREATOR_DETAILS_ACTION_TYPES = {
    SET_FEATURE_ACCESSIBILITY: "@CREATOR_DETAILS/SET_FEATURE_ACCESSIBILITY",
} as const;
